import { GetServerSidePropsContext } from 'next';
import qs from 'qs';
import { dateService } from 'services/DateService';
import {
  ExperienceTicket,
  ExperienceTicketCancelPayload,
  ExperienceTicketCreatePayload,
  ExperienceTicketsGetPayload,
  ExperienceTicketState,
} from 'types/experience/experience-ticket.type';
import { PaginatedResponse } from 'types/search.type';
import { client } from 'utils/axios';
import { ssrRequest } from 'utils/ssrRequestFactory';

class ExperienceTicketService {
  getExperienceTicketsPayload(page: number): string {
    const dayjs = dateService.getDayjs();
    const basePayload: ExperienceTicketsGetPayload = {
      startDate: dateService.formatDateToServerDateString(
        dayjs().subtract(1, 'year').toDate()
      ),
      endDate: dateService.formatDateToServerDateString(
        dayjs().add(1, 'year').toDate()
      ),
      pagination: {
        page: page,
        size: 5,
        sort: ['timeStamps.createdAt,desc'],
      },
      state: [
        ExperienceTicketState.WAITING_DUE_DATE,
        ExperienceTicketState.ON_GOING,
        ExperienceTicketState.CANCELLED,
        ExperienceTicketState.DONE,
      ],
    };

    return qs.stringify(basePayload, {
      allowDots: true,
      arrayFormat: 'repeat',
    });
  }

  async getExperienceTicketsSSR(
    ctx: GetServerSidePropsContext
  ): Promise<PaginatedResponse<ExperienceTicket[]>> {
    const paramsQs = experienceTicketService.getExperienceTicketsPayload(0);
    return ssrRequest(`/v1/customer/experience/tickets?${paramsQs}`, ctx);
  }

  async getExperienceTickets(
    page: number
  ): Promise<PaginatedResponse<ExperienceTicket[]>> {
    const paramsQs = experienceTicketService.getExperienceTicketsPayload(page);
    const { data } = await client.get(
      `/v1/customer/experience/tickets?${paramsQs}`
    );
    return data;
  }

  async createTicket(
    payload: ExperienceTicketCreatePayload
  ): Promise<ExperienceTicket> {
    const { data } = await client.post(
      '/v1/customer/experience/tickets',
      payload
    );
    return data;
  }

  async cancelTicket(
    ticketId: number,
    payload: ExperienceTicketCancelPayload
  ): Promise<void> {
    const { data } = await client.put(
      `/v1/customer/experience/tickets/${ticketId}/cancel`,
      payload
    );
    return data;
  }
}

export const experienceTicketService = new ExperienceTicketService();
